import React from 'react';
import { QrCode2, Download } from '@mui/icons-material';
import { Card, Icon, IconButton, Link, Row, Stack, Text } from 'library/ui';
import { Address } from 'models';
import LocationQRCode from './LocationQRCode';
import { downloadQRCode } from './downloadQRcode';

export default function QRCodeCard({ address }: { address: Address }) {
    return (
        <Card padding="sm">
            <Row justify="between" align="center" gap="md">
                <Row gap="sm" align="center">
                    <Icon icon={QrCode2} size="sm" />
                    <Stack gap="none">
                        <Link href={`/clock-in/?loc_id=${address.id}`}>{address.description}</Link>
                        <Text size="sm" tone="secondary">
                            {address.street} {address.city} {address.state} {address.zip_code}
                        </Text>
                    </Stack>
                </Row>
                <IconButton icon={Download} tooltip="Download" onClick={() => downloadQRCode(address)} />
            </Row>
            <div style={{ display: 'none' }}>
                <LocationQRCode addressId={String(address.id)} />
            </div>
        </Card>
    );
}
